/* Horizon owns the cart, the market and product availability. This script only handles Curvila's local UI. */
(() => {
  const doc = document;
  const cleanup = new WeakMap();
  function reviewTarget() {
    return doc.querySelector('[data-cvn-reviews]');
  }
  function linkReviews() {
    const target = reviewTarget();
    doc.querySelectorAll('[data-cvn-review-link]').forEach(link => {
      if (target) link.href = '#' + target.id;
      else link.removeAttribute('href');
    });
  }
  function openGuide(root) {
    const dialog = root?.querySelector('[data-cvn-guide]');
    if (!dialog || dialog.open) return;
    dialog.showModal();
    dialog.querySelector('[data-cvn-close]')?.focus();
  }
  function filterReviews(section, topic = '', limit) {
    const more = section.querySelector('[data-cvn-review-more]');
    const pageSize = Number(more?.dataset.cvnReviewMore) || Infinity;
    const shown = limit ?? pageSize;
    let matched = 0;
    section.querySelectorAll('[data-cvn-topic]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.cvnTopic === topic)));
    section.querySelectorAll('[data-cvn-review-topic]').forEach(card => {
      const included = !topic || card.dataset.cvnReviewTopic === topic;
      card.hidden = !included || ++matched > shown;
    });
    if (more) {
      more.hidden = matched <= shown;
      more.dataset.shown = String(shown);
    }
  }
  function bind(scope = doc) {
    linkReviews();
    scope.querySelectorAll('[data-cvn-reviews]:has([data-cvn-review-more])').forEach(section => filterReviews(section));
    const roots = scope.querySelectorAll('[data-cvn-product]');
    for (const root of roots) {
      if (cleanup.has(root)) continue;
      const sticky = root.querySelector('[data-cvn-sticky]');
      const purchase = root.querySelector('.cvn-b-purchase');
      if (!sticky || !purchase || !purchase.querySelector('form') || !window.IntersectionObserver) continue;
      const observer = new IntersectionObserver(([entry]) => {sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;});
      observer.observe(purchase);
      cleanup.set(root, observer);
    }
  }
  doc.addEventListener('click', event => {
    const btn = event.target.closest('button,a');
    const root = event.target.closest('[data-cvn-product]');
    if (event.target.matches('dialog[data-cvn-guide]') && event.target === event.target.closest('dialog')) {
      const rect=event.target.getBoundingClientRect();
      if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();
    }
    if (!btn) return;
    if (btn.matches('[data-cvn-guide-open]')) openGuide(root);
    else if (btn.matches('[data-cvn-close]')) btn.closest('dialog')?.close();
    else if (btn.matches('[data-unit-choice]')) {
      const dialog = btn.closest('dialog');
      dialog.querySelectorAll('[data-unit-choice]').forEach(el=>el.setAttribute('aria-pressed',String(el===btn)));
      dialog.querySelectorAll('[data-unit]').forEach(el=>{el.hidden = el.dataset.unit !== btn.dataset.unitChoice;});
    } else if (btn.matches('[data-cvn-review-link]') && reviewTarget()) {
      event.preventDefault();
      const target=reviewTarget();target.focus({preventScroll:true});target.scrollIntoView({block:'start'});
    } else if (btn.matches('[data-cvn-review-step]')) {
      const rail=btn.closest('[data-cvn-reviews]').querySelector('.cvn-review-track');
      const first=rail.querySelector('figure:not([hidden])');
      if (first) rail.scrollBy({left:(first.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap)||0))*Number(btn.dataset.cvnReviewStep),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    } else if (btn.matches('[data-cvn-topic]')) {
      const section=btn.closest('[data-cvn-reviews]');
      filterReviews(section,btn.dataset.cvnTopic);
    } else if (btn.matches('[data-cvn-review-more]')) {
      const section=btn.closest('[data-cvn-reviews]');
      const topic=section.querySelector('[data-cvn-topic][aria-pressed="true"]')?.dataset.cvnTopic || '';
      filterReviews(section,topic,Number(btn.dataset.shown)+Number(btn.dataset.cvnReviewMore));
    } else if (btn.matches('[data-cvn-sticky-buy]')) {
      const purchase=doc.getElementById('CvNativePurchase-'+root.dataset.cvnProduct);
      if (purchase?.addFromSticky) purchase.addFromSticky();
      else root.querySelector('.cvn-b-purchase')?.scrollIntoView({block:'center'});
    }
  });
  doc.addEventListener('cv-native:guide',e=>openGuide(e.target.closest('[data-cvn-product]')));
  doc.addEventListener('shopify:block:select',event=>{
    const card=event.target.closest?.('.cvn-review-card');
    if (!card) return;
    if (card.hidden) filterReviews(card.closest('[data-cvn-reviews]'),'',Infinity);
    card.scrollIntoView({block:'nearest',inline:'nearest'});
  });
  doc.addEventListener('shopify:section:load',e=>bind(e.target));
  doc.addEventListener('shopify:section:unload',e=>{
    e.target.querySelectorAll('[data-cvn-product]').forEach(el=>{cleanup.get(el)?.disconnect();cleanup.delete(el);});
    requestAnimationFrame(linkReviews);
  });
  doc.addEventListener('shopify:block:select',e=>{
    const card=e.target.closest('[data-cvn-review-topic]');
    if(card){card.hidden=false;card.scrollIntoView({block:'nearest',inline:'center'});}
  });
  bind();
})();
if (!customElements.get('cv-related')) {
  customElements.define('cv-related', class extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-recommendations') || !window.IntersectionObserver) return;
      this.observer = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) return;
        this.observer.disconnect();
        this.controller = new AbortController();
        fetch(this.dataset.url,{signal:this.controller.signal}).then(r=>r.ok?r.text():'').then(html=>{
          if (!html || !this.isConnected) return;
          const next=new DOMParser().parseFromString(html,'text/html').querySelector('cv-related');
          if(next?.querySelector('.cvn-related-grid')?.children.length) this.innerHTML=next.innerHTML;
        }).catch(()=>{});
      },{rootMargin:'160px'});
      this.observer.observe(this);
    }
    disconnectedCallback() {this.observer?.disconnect();this.controller?.abort();}
  });
}
document.addEventListener('cv-native:state', e => {
  const root=e.target.closest('[data-cvn-product]');
  const sticky=root?.querySelector('[data-cvn-sticky-buy]');
  if (!sticky) return;
  const state=e.detail;
  if (state?.label) sticky.textContent=state.needsSize && sticky.dataset.choiceLabel ? sticky.dataset.choiceLabel : state.label;
  sticky.disabled=Boolean(state?.busy || (state?.canAdd===false && !state?.needsSize));
});
if (location.hash==='#cv-size-guide') {
  document.querySelector('[data-cvn-guide]')?.showModal();
}
